enum TradingStatus {
    DEFAULT = '',
    PERSONAL = 'personal',
    COMPANY = 'company',
    CC = 'cc',
}

export default TradingStatus
